import React from "react";
import { ThemeProvider } from "styled-components";
import { defaultTheme } from "./src/theme";

export const wrapRootElement = ({ element }) => <ThemeProvider theme={defaultTheme}>{element}</ThemeProvider>;
